import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { useSYS4120_R01Store } from "./Store_SYS4120_R01";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { useState } from "react";



export const SearchSection_SYS4120_R01 = () => {

  const { SYS4120_R01Filter, setSYS4120_R01Filter } = useSYS4120_R01Store();
  const { yesNoList } = useCommonCodeStore();

  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
	<SearchSectionForm>
		
		<SearchDateRangeForm
				label="게시 기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={SYS4120_R01Filter.dateRange}		setDateRange={(dateRange) => setSYS4120_R01Filter({ dateRange })}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
				wrapperOption = {{
					wrapperStyle: 'w-[270px] min-w-[270px] ',
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[60px] min-w-[60px]',
					dateRangeStyle: 'w-[160px] min-w-[160px] border border-gray-300 py-[1px] px-[10px] h-[24px] rounded-[6px]',
				}}
			/>

		<SearchDropDownForm
			label="최상단 고정"
			value={SYS4120_R01Filter.topNotice}
			optionList={yesNoList}
			onChangeItem={(selectedItem) => setSYS4120_R01Filter({ topNotice: selectedItem?.minorCd || '' })}
			wrapperOption = {{
				wrapperStyle: 'w-[220px] min-w-[220px] ',
				titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[70px] min-w-[70px]',
				selectStyle: 'w-[120px] min-w-[120px] ',
			}}
		/>
		
	</SearchSectionForm>
  )
}